/**
 * Returns a subset of a data set based on the current page, and the items per page.
 *
 * @public
 * @param  {Array} data The entire data set.
 * @param  {Number} page The current page number.
 * @param  {Number} itemsPerPage The size of one page.
 * @return {Array} A new Array that is a subset of the original data set, and contains only the items for the
 *   current page. The original data set will not be affected.
 */
export const paginate = (data, page, itemsPerPage) => {
  const zeroIndexPage = page - 1;
  const paginatedData = data.slice(zeroIndexPage * itemsPerPage, (zeroIndexPage + 1) * itemsPerPage);
  return paginatedData;
};
/**
 * It gives page offset based on page and itemsPerPage.
 * It is used for displaying row numbers.
 * @param  {Number} page Current page number
 * @param  {Number} itemsPerPage Number of items displayed per page
 * @return {Number}
 */

export const getPageOffset = (page, itemsPerPage) => (page - 1) * itemsPerPage + 1;